function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CaptchaComponent from '../../../../components/CaptchaComponent.vue';
import HelpCenterService from './js/help_center_service';
import tasks from '@/js/tasks';
import { firebaseConfig, GA_EVENTS } from '@/js/constants';
import { mapState } from 'vuex';
export default {
  components: {
    CaptchaComponent: CaptchaComponent
  },
  data: function data() {
    return {
      sugerence: []
    };
  },
  props: {
    isModal: {
      type: Boolean
    }
  },
  methods: {
    getBack: function getBack() {
      this.$router.push({
        name: "help_main"
      });
    },
    onSubmit: function onSubmit() {
      var _this = this;
      if (!this.$refs.formsugerences.validate()) return;
      if (!this.sugerence.comentario) this.sugerence.comentario = "";
      var data = {
        values: {
          "seccion": this.sugerence.seccion,
          "detalles": this.sugerence.detalles,
          "comentario": this.sugerence.comentario,
          "informante": window.userInfo.email
        }
      };
      HelpCenterService.createSugerence(data).then(function (response) {
        console.log(response);
        if (response.success === true) {
          tasks.toast.success('Creado correctamente');
          //this.$toast.success("Creado")
          _this.sugerence = [];
          if (_this.$gtm.enabled() && window.dataLayer) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: GA_EVENTS.HELP_CENTER_VIEW,
              type: 'sugerence',
              company_code: _this.companyCode,
              hash_email: _this.stringToHash(userInfo.email),
              'module': 'data_platform'
            });
          }
        }
      }, function (err) {
        tasks.toast.error('Error');
        //this.$toast.warning("Error")
      });
    }
  },
  computed: _objectSpread({
    breadcrumbs: function breadcrumbs() {
      return [{
        text: "Centro de ayuda",
        disabled: false,
        href: '/#/help_center/MainPage'
      }, {
        text: "Buzón de sugerencias",
        disabled: true
      }];
    }
  }, mapState('data-platform', ['companyCode', 'companyName']))
};